import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SharedPipesModule} from '@shared/pipes/pipes.module';
import {DirectivesModule} from '@shared/directives/directives.module';
import {LeagueRouting} from '@modules/league/league.routing';
import {LeagueNewsComponent} from '@modules/league/pages/league-news/league-news.component';
import {LeagueStartPageComponent} from '@modules/league/pages/league-start-page/league-start-page.component';
import {LeagueTeamsComponent} from '@modules/league/pages/league-teams/league-teams.component';
import {SharedModule} from '@shared/shared.module';
import {VotingModule} from '@modules/voting/voting.module';
import {SharedNewsModule} from '@shared/modules/shared-news/shared-news.module';
import {LibTableModule} from '@lib-modules/table/lib-table.module';
import { LeagueVideosComponent } from './pages/league-videos/league-videos.component';
import {SharedVideosModule} from '@shared/modules/shared-videos/shared-videos.module';
import {SharedGamesModule} from '@shared/modules/shared-games/shared-games.module';
import {LibAdCampaignModule} from '@components/ad-campaign/lib-ad-campaign.module';
import {SharedNewsListModule} from '@shared/modules/shared-news-list/shared-news-list.module';
import {SharedNewsDetailModule} from '@shared/modules/shared-news-detail/shared-news-detail.module';
import {LibBettingGameModule} from '@components/betting-game/lib-betting-game.module';
import { LeagueStatisticsComponent } from './pages/league-statistics/league-statistics.component';
import {LibDirectivesModule} from '@utils/directives/lib-directives.module';
import {SharedBannersModule} from '@shared/modules/shared-banners/shared-banners.module';
import { LeagueTransfersComponent } from './pages/league-transfers/league-transfers.component';
import { LeagueMatchesComponent } from './pages/league-matches/league-matches.component';
import { LeagueMatchesWrapperComponent } from './pages/league-matches-wrapper/league-matches-wrapper.component';
import { LibGamesModule } from '@components/games/lib-games.module';
import {PickerModule} from '@lib-modules/picker/picker.module';
import {LibSectionModule} from '@lib-modules/section/lib-section.module';
import { LeagueHomeComponent } from './pages/league-home/league-home.component';
import {LeagueReplaysComponent} from '@modules/league/pages/league-replays/league-replays.component';
import { LeagueLivestreamsComponent } from './pages/league-livestreams/league-livestreams.component';

@NgModule({
  declarations: [
    LeagueStartPageComponent,
    LeagueNewsComponent,
    LeagueMatchesWrapperComponent,
    LeagueMatchesComponent,
    LeagueTeamsComponent,
    LeagueVideosComponent,
    LeagueStatisticsComponent,
    LeagueTransfersComponent,
    LeagueHomeComponent,
    LeagueReplaysComponent,
    LeagueLivestreamsComponent,
  ],
  imports: [
    CommonModule,
    LeagueRouting,
    SharedPipesModule,
    DirectivesModule,
    SharedModule,
    VotingModule,
    SharedNewsModule,
    SharedNewsDetailModule,
    SharedNewsListModule,
    LibTableModule,
    SharedVideosModule,
    SharedGamesModule,
    LibAdCampaignModule,
    LibBettingGameModule,
    LibDirectivesModule,
    SharedBannersModule,
    LibGamesModule,
    PickerModule,
    LibSectionModule,
  ],
})
export class LeagueModule { }
